/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import React, { ReactElement, useEffect, useRef, useState } from 'react';
// eslint-disable-next-line import/no-named-default
import videojs from 'video.js';
import styled from 'styled-components';
import {
  Avatar,
  Box,
  Flex,
  Icon,
  IconButton,
  Button,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Text,
  Drawer,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Portal,
  useDisclosure,
  Grid,
  Image,
} from '@chakra-ui/react';
import { AiOutlineComment } from 'react-icons/ai';
import { IonIcon, IonChip, IonButton, IonLabel } from '@ionic/react';
import { closeOutline, caretDown, close } from 'ionicons/icons';
import { BsChatFill } from 'react-icons/bs';
import { FiChevronLeft } from 'react-icons/fi';
import {
  Prompt,
  PromptState,
  QuestionResponse,
  VideoResponse,
  AudioResponse,
  ImageResponse,
  User,
} from '../../../@types';
import { respond } from '../../../theme/mixins';
import { PromptLikeButton } from './PromptLikeButton';
import { Emoji } from '../../emoji';
import * as Constants from '../../../constants';
import { ResponseComments } from './ResponseComments';
import { useEpisodeStore } from '../../../store';
import {
  usePromptLike,
  usePrompt,
  useCurrentUser,
  useResponseComments,
  usePromptResponses,
} from '../../../api';
import { showNotification } from '../../notification';
import { ReactionsWrapper } from '../styles/ReactionsWrapper';
import RenderRawHtml from '../../../components/RenderRawHtml';

const TextResponseStyle = styled.div`
  font-size: 1rem;
  text-align: left;
  padding: 20px 30px;
  box-shadow: #e1dfdf 1px 1px 20px -4px;
  width: 100%;
  max-width: 500px;
  border-radius: 10px;
  background: #f1f3f53b;
  color: #303030;
  border: 1px solid #e7e7e7;
  margin-bottom: 20px;
`;
const DescriptionBox = styled.div`
  font-size: 1rem;
  text-align: left;
  margin-left: 25px;
  padding: 20px;
  box-shadow: #e1dfdf 1px 1px 20px -4px;
  max-width: 400px;
  border-radius: 10px;
  background: #f1f3f53b;
  color: #303030;
  border: 1px solid #e7e7e7;
`;
const ResponseViewContainer = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
  transform: translateY(300px);
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  transition: opacity 0.2s, transform 0.4s, visibility 0s;
  display: flex;
  flex-direction: column;
  border-radius: 0 0 10px 10px;

  .btn-close {
    display: flex;
    margin: 0 auto;
    transition: opacity 0.1s;
    align-items: center;
    opacity: 1;
    color: #dcdcdc;
    padding: 0 20px 3px;
    justify-content: center;
    width: 110px;
    min-height: 40px;
    z-index: 10;
    --box-shadow: none;
    --border-radius: 0 0 4px 4px;

    ion-icon {
      font-size: 24px;
    }
    &:hover,
    &:focus {
      opacity: 1;
    }
  }

  &.open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
    /* border-top: 2px solid var(--ion-color-primary); */
  }
  .response-audio {
    width: 100%;
  }
  .response {
    display: flex;
    width: 100%;
    height: calc(100% - 50px);
    .chakra-modal__content-container {
      width: auto;
      height: auto;
    }

    .response-content {
      width: 100%;
      position: relative;
      height: 100%;
      header {
        display: block;
        justify-content: center;
        align-items: center;
        margin-top: 0;
        text-align: left;
        padding: 0 35px 10px;
      }
      .video-container {
        width: 100%;
        margin: 0 auto;
        direction: ltr;
      }
      .response-reactions {
        /* direction: ltr;
                width: 90px;
                justify-content: flex-start;
                margin: 3px 0 0 20px;
                flex-direction: column; */
        /* .reaction-type {
                    margin: 8px 0;
                } */
      }
      > div {
        height: 100%;
        width: 100%;
      }
      img.response-image {
        height: calc(100% - 50px);
        width: auto;
        border-radius: 20px;
      }

      video {
        width: auto;
        border-radius: 0;
        position: relative;
      }
    }
    .response-comments {
      flex-grow: 1;
      position: relative;
      border-left: 1px solid #eee;

      header {
        margin-bottom: 10px;
        margin-top: -20px;

        i {
          font-size: 18px;
          margin: 0 7px 0 -10px;
        }
      }
      .comment-feed {
        height: calc(100% - 50px);
        .feed-inner {
          padding-top: 10px;
          padding-bottom: 50px;

          .no-comments {
            display: flex;
            padding: 30px;
            justify-content: center;
            align-items: center;
            color: var(--ion-color-medium);
            font-size: 0.9rem;
          }
          .comment-replies {
            opacity: 0;
            height: 0;
            pointer-events: none;
            list-style: none;
            margin: 0;
            padding: 0;
            display: none;
            ion-avatar {
              width: 25px;
              height: 25px;
              margin: 2px 10px 0 0;
            }
            &.open {
              opacity: 1;
              display: block;
              height: 100%;
              pointer-events: auto;
              padding: 10px 2px 30px;
            }
            li {
              display: flex;
              align-items: flex-start;
              &.li-list-end {
                justify-content: flex-end;
                border-bottom: 1px solid #eee;
              }
            }
          }
        }
        .comment-action {
          margin: 25px 10px;
          display: flex;
          align-items: center;
          max-width: 30px;
          padding: 0;
          ion-icon {
            font-size: 24px;
          }
        }
      }
    }
    ${respond.down('sm')} {
      flex-wrap: wrap;
      .response-content {
        width: 100%;
      }
    }
  }
  header {
    i {
      font-size: 18px;
    }
    button[disabled] {
      color: #999;
    }
    > span {
      font-size: 0.9rem;
      display: block;
      color: #888;
      /* margin: -10px 0 0px 0; */
      position: relative;
      /* top: -10px; */
    }
    .user {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-wrap: wrap;
      .rs-avatar {
        display: inline-flex;
        border: 2px solid;
        border-radius: 50%;
        padding: 4px;
        border-color: #6c96ce;
        box-sizing: content-box;
        background: #fff;
        justify-content: center;
        align-items: center;
        img {
          height: 35px;
          width: 35px;
        }
      }
      .details {
        margin: 5px 8px;
        font-size: 1rem;
        font-weight: 500;
        .secondary {
          font-size: 0.75rem;
          color: rgba(var(--ion-color-dark-rgb), 0.6);
        }
      }
    }
  }
`;
const ResponseReactions: React.FC<{
  response: QuestionResponse | VideoResponse | ImageResponse;
}> = ({ response }) => {
  const { data: user } = useCurrentUser();

  const onReactionClick = (typeId: string) => {
    //      state: PromptState,
    // dispatch: PromptDispatch,
    // responseId: string,
    // reactionType: number,
    // user: User
    // if (AuthStore.user) {
    //     toggleResponseReaction(
    //         PromptState,
    //         PromptDispatch,
    //         response.id,
    //         typeId,
    //         AuthStore.user
    //     );
    // }
  };

  return (
    <ReactionsWrapper className="response-reactions">
      {Object.entries(Constants.REACTION_TYPE_IDS).map(([type, typeId]) => {
        if (!response.reactions || !response.reactions[typeId]) {
          return null;
        }
        const isSelected =
          user &&
          response.reactions &&
          response.reactions[typeId] &&
          response.reactions[typeId].users.filter((u) => u.user_id === user.id)
            .length;

        const count =
          response.reactions && response.reactions[typeId]
            ? response.reactions[typeId].users.length
            : 0;

        const { emoji } = Constants.REACTION_TYPES[typeId];

        return (
          <div
            key={typeId}
            className={`reaction-type type-${typeId} ${
              isSelected ? 'selected' : ''
            }`}
          >
            <IonChip
              onClick={(e) => onReactionClick(typeId)}
              outline
              color="primary"
            >
              <Emoji emoji={emoji} />
              <IonLabel>{count}</IonLabel>
            </IonChip>
          </div>
        );
      })}
    </ReactionsWrapper>
  );
};

export const ImageResponseWrapper: React.FC<{
  response: ImageResponse;
  isEditView?: boolean;
}> = ({ response, isEditView = false }) => {
  const MEDIA_URL = `https://media.belouga.org/v2-uploads/responses/${response.episode_prompt_id}/l_${response.media_src}`;

  return (
    <>
      {response && response.media_src && (
        <Image
          h={300}
          w="full"
          objectFit="contain"
          alt="Response"
          src={MEDIA_URL}
        />
      )}
      {response?.text && !isEditView && (
        <Text
          mt={2}
          textAlign="left"
          w="full"
          color="darkBlue.500"
          fonrSize="sm"
        >
          {response.text}
        </Text>
      )}
    </>
  );
};

export const AudioResponseWrapper: React.FC<{
  response: VideoResponse;
  isEditView?: boolean;
}> = ({ response, isEditView = false }) => {
  const [playerReady, setPlayerReady] = useState(false);
  const MEDIA_URL = `https://media.belouga.org/v2-uploads/responses/${response.episode_prompt_id}/${response.media_src}.m4a`;
  const [shouldRetry, setShouldRetry] = useState<false | number>(false);
  const [mediaLoaded, setMediaLoaded] = useState(false);
  const loadingPoller = useRef<any>(null);

  useEffect(() => {
    if (!!shouldRetry && !loadingPoller.current) {
      loadingPoller.current = setInterval(function () {
        setShouldRetry(shouldRetry + 1);
      }, 2000);
    }
    const audio = new Audio();
    audio.onloadeddata = () => {
      setShouldRetry(false);
      setTimeout(() => {
        setMediaLoaded(true);
      }, 100);
      clearInterval(loadingPoller.current);
    };
    audio.src = MEDIA_URL;
  }, [shouldRetry]);

  useEffect(() => {
    const audio = new Audio();
    audio.onerror = () => {
      setShouldRetry(1);
    };
    audio.onloadeddata = () => {
      setTimeout(() => {
        setMediaLoaded(true);
      }, 100);
    };
    audio.src = MEDIA_URL;
  }, []);
  return (
    <div className="audio-container">
      {response && response.media_src && !!mediaLoaded && (
        <audio controls className="response-audio">
          <source src={MEDIA_URL} />
        </audio>
      )}
      {response?.text && !isEditView && (
        <Text
          mt={2}
          textAlign="left"
          w="full"
          color="darkBlue.500"
          fonrSize="sm"
        >
          {response.text}
        </Text>
      )}
    </div>
  );
};

export const VideoResponseWrapper: React.FC<{
  response: VideoResponse;
  isEditView?: boolean;
}> = ({ response, isEditView = false }) => {
  const [playerReady, setPlayerReady] = useState(false);
  const HD_WEBM_MEDIA_URL = `https://media.belouga.org/v2-uploads/responses/${response.episode_prompt_id}/HD_${response.media_src}.webm`;
  const HD_MP4_MEDIA_URL = `https://media.belouga.org/v2-uploads/responses/${response.episode_prompt_id}/HD_${response.media_src}.mp4`;
  const SD_MP4_MEDIA_URL = `https://media.belouga.org/v2-uploads/responses/${response.episode_prompt_id}/SD_${response.media_src}.mp4`;
  const videoJSOptions = {
    fluid: true,
    controls: true,
    userActions: { hotkeys: true },
    playbackRates: [0.5, 1, 1.5, 2],
    sources: [
      {
        src: HD_WEBM_MEDIA_URL,
        type: 'video/webm',
      },
      {
        src: HD_MP4_MEDIA_URL,
        type: 'video/mp4',
      },
      {
        src: SD_MP4_MEDIA_URL,
        type: 'video/mp4',
      },
    ],
  };
  const videoPlayerRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const p = videojs(videoPlayerRef.current, videoJSOptions, () => {});
    p.on('error', function () {
      if (p.error()?.code === 4) {
        p.src(videoJSOptions.sources[1].src);
      }
    });
    p.ready(function () {
      setPlayerReady(true);
    });
    return () => {
      setPlayerReady(false);
      p.dispose();
    };
  }, [response]);
  return (
    <>
      <div className="video-container">
        {response && response.media_src && (
          <video
            ref={videoPlayerRef}
            className="video-js response-video"
            controls
          />
        )}
      </div>
      {response?.text && !isEditView && (
        <Text
          mt={2}
          textAlign="left"
          w="full"
          color="darkBlue.500"
          fonrSize="sm"
        >
          {response.text}
        </Text>
      )}
    </>
  );
};

export const QuestionResponseView: React.FC<{
  promptId: string;
  responses: [QuestionResponse[]];
}> = ({ promptId, responses }) => {
  const { getPromptStateById, PROMPT_ACTIONS } = useEpisodeStore((state) => ({
    getPromptStateById: state.getPromptStateById,
    PROMPT_ACTIONS: state.PROMPT_ACTIONS,
  }));
  const viewerRef = useRef(null);
  const state = getPromptStateById(promptId);
  const { data: user } = useCurrentUser();
  const { currentResponse, prompt } = state;
  const [currentUserResponse, setCurrentUserResponse] = useState<any>(null);

  const {
    isOpen: commentsOpen,
    onClose: onCloseComments,
    onOpen: onOpenComments,
  } = useDisclosure();

  const { data: comments, isLoading: commentsLoading } = useResponseComments(
    !!currentUserResponse ? currentUserResponse.id : null
  );
  const allFromUser =
    currentResponse &&
    responses.find(
      (responsesByUser: any) =>
        responsesByUser[0].user_id === currentResponse[1]
    );

  useEffect(() => {
    if (currentResponse) {
      const res = responses.find(
        (responsesByUser: any) =>
          responsesByUser[0].user_id === currentResponse[1]
      );
      setCurrentUserResponse(res && res[0]);
    }
  }, [currentResponse]);

  console.log(state);

  if (!state.prompt || !currentUserResponse || !allFromUser) {
    return null;
  }

  const { username, icon, avatar } = currentUserResponse.user;
  const handleCloseViewer = () => {
    PROMPT_ACTIONS.closeResponseViewer(promptId);
  };
  const handleTabsChange = (index: number) => {
    if (allFromUser) {
      setCurrentUserResponse(
        allFromUser.find((res: any) => res.response_type === index + 1)
      );
    }
  };

  const isMyResponse = user && currentUserResponse.user_id === user.id;

  return (
    <ResponseViewContainer className={state.responsesOpen ? 'open' : ''}>
      <Button
        color="gray.500"
        w="fit-content"
        variant="ghost"
        onClick={(e) => handleCloseViewer()}
        leftIcon={<Icon as={FiChevronLeft} />}
        ml={3}
      >
        back
      </Button>

      <Box ref={viewerRef} className="response">
        <div className="response-content">
          <Tabs
            index={currentUserResponse.response_type - 1}
            onChange={handleTabsChange}
          >
            <Grid templateColumns="1fr 1fr" gap={8} px={8}>
              <Flex flexDir="column" gap={4}>
                <Text
                  fontSize="lg"
                  fontWeight={500}
                  w="full"
                  color="darkBlue.500"
                  textAlign="start"
                >
                  <RenderRawHtml>{prompt?.text}</RenderRawHtml>
                </Text>
                <Flex
                  bg="ligthBlue.500"
                  p={4}
                  borderRadius={24}
                  gap={4}
                  pr={20}
                  w="fit-content"
                >
                  <Avatar size="lg" name={username} src={avatar} />
                  <Flex flexDir="column" justifyContent="center">
                    <Box position="relative">
                      <Text fontSize={14} fontWeight={800} isTruncated>
                        {username}
                      </Text>

                      {isMyResponse && (
                        <Text
                          position="absolute"
                          bg="red.400"
                          color="white"
                          fontSize={10}
                          top={-4}
                          right={-6}
                          fontWeight={700}
                          w={7}
                          h={7}
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          borderRadius="full"
                          mt={0}
                        >
                          You
                        </Text>
                      )}
                    </Box>

                    <Flex alignItems="center" gap={1}>
                      <Icon as={BsChatFill} />
                      <Text fontSize={12} fontWeight={600} mt={1}>
                        {currentUserResponse?.response_comments?.length}
                      </Text>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
              <Flex flexDir="column">
                <TabList
                  border="1px solid #dddddd"
                  borderRadius="full"
                  {...{
                    flexGrow: 1,
                    justifyContent: 'space-evenly',
                  }}
                >
                  {Object.values(Constants.RESPONSE_TYPE_IDS).map(
                    (responseType, index) => {
                      if (responseType === Constants.RESPONSE_TYPE_IDS.DRAW)
                        return null;
                      return (
                        <Tab
                          isDisabled={
                            !allFromUser.find(
                              (r: any) => r.response_type === responseType
                            )
                          }
                          borderLeft={
                            index === 0 ? 'none' : '1px solid #dddddd'
                          }
                          bg="none"
                          flexGrow={1}
                          key={responseType}
                          pb={3}
                          _selected={{
                            color: 'blue.500',
                          }}
                          sx={{
                            '.rs-icon': {
                              fontSize: '22px',
                            },
                            _hover: {
                              color: 'blue.400',
                            },
                          }}
                        >
                          {Constants.RESPONSE_TYPE_ICONS[responseType]}
                        </Tab>
                      );
                    }
                  )}
                </TabList>

                <TabPanels h={400}>
                  {Object.values(Constants.RESPONSE_TYPE_IDS).map(
                    (responseType, i) => {
                      const response = allFromUser.find(
                        ({ response_type }) => response_type === responseType
                      );
                      if (!response) {
                        return <TabPanel key={`p-${i}`} />;
                      }
                      return (
                        <TabPanel
                          h="100%"
                          overflowY="auto"
                          overflowX="hidden"
                          key={response.id}
                        >
                          {response.response_type ===
                            Constants.RESPONSE_TYPE_IDS.TEXT &&
                            state.responsesOpen && (
                              <TextResponseStyle>
                                {response.text}
                              </TextResponseStyle>
                            )}

                          {response.response_type ===
                            Constants.RESPONSE_TYPE_IDS.VIDEO &&
                            state.responsesOpen && (
                              <VideoResponseWrapper
                                response={response as VideoResponse}
                              />
                            )}
                          {response.response_type ===
                            Constants.RESPONSE_TYPE_IDS.IMAGE &&
                            state.responsesOpen && (
                              <ImageResponseWrapper
                                response={response as ImageResponse}
                              />
                            )}
                          {response.response_type ===
                            Constants.RESPONSE_TYPE_IDS.AUDIO &&
                            state.responsesOpen && (
                              <AudioResponseWrapper
                                response={response as AudioResponse}
                              />
                            )}
                          {/* <ResponseReactions response={response} /> */}
                          <Flex>
                            <Button
                              size="md"
                              variant="ghost"
                              color="darkBlue.500"
                              rounded="lg"
                              fontWeight="medium"
                              aria-label="Open Comments"
                              leftIcon={<Icon fontSize="md" as={BsChatFill} />}
                              onClick={onOpenComments}
                              mb={4}
                              px={0}
                            >
                              {comments?.length}
                            </Button>
                          </Flex>
                        </TabPanel>
                      );
                    }
                  )}
                </TabPanels>
              </Flex>
            </Grid>
          </Tabs>
        </div>
      </Box>
      {state.responsesOpen && currentUserResponse && (
        <Portal containerRef={viewerRef}>
          <Drawer
            trapFocus={false}
            isOpen={commentsOpen}
            onClose={onCloseComments}
          >
            <DrawerContent
              minW="400px"
              boxShadow="#22222261 0 0 27px -7px"
              rounded="lg"
              top={-10}
            >
              <DrawerCloseButton
                variant="ghost"
                bg="gray.50"
                size="md"
                zIndex="popover"
                mt={0}
                top={1}
              />

              <DrawerBody pb={1} pt={1} px={0}>
                {comments && (
                  <ResponseComments
                    responseId={currentUserResponse.id}
                    promptId={state.prompt.id}
                    isModerator={isMyResponse || false}
                    comments={comments}
                    commentsLoading={commentsLoading}
                  />
                )}
              </DrawerBody>
            </DrawerContent>
          </Drawer>
        </Portal>
      )}
    </ResponseViewContainer>
  );
};
